<ng-container *ngIf="GraphType=='line'">
    <kendo-chart [style]="newstyle">
        <kendo-chart-title [text]="GraphTitle"></kendo-chart-title>
        <kendo-chart-legend *ngIf="LegendLabel" position="bottom" [padding]="0" [height]="300" [visible]="true">
        </kendo-chart-legend>
        <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [categories]="Categories">
            </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-series>
            <kendo-chart-series-item *ngFor="let dataItem of Data" name="a" [type]="GraphType" [data]="dataItem"
                [markers]="{ visible: false }" [style]="style">
                <kendo-chart-series-item-labels *ngIf="WithLabel" [format]="'n2'">
                </kendo-chart-series-item-labels>
            </kendo-chart-series-item>
        </kendo-chart-series>
    </kendo-chart>
</ng-container>

<ng-container *ngIf="GraphType=='bar'">
    <kendo-chart>
        <kendo-chart-series>
            <ng-container *ngFor="let res of Data">
                <kendo-chart-series-item type="bar" type="column" [gap]="2" [spacing]=".25"   [color]= "color"  [data]="res">
                </kendo-chart-series-item>
            </ng-container>
        </kendo-chart-series>
        <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [categories]="Categories">
            </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
    </kendo-chart>
    <!-- <kendo-chart [style]="newstyle" renderAs="canvas" 
     [pannable]="true" [zoomable]="{ mousewheel: { rate: zoomRate } }"> 
   
        <kendo-chart-title [text]="GraphTitle"></kendo-chart-title>
        <kendo-chart-legend *ngIf="LegendLabel" position="bottom" 
        [padding]="0" [height]="300" [visible]="true"></kendo-chart-legend>
        <kendo-chart-series>
            <kendo-chart-series-item *ngFor="let dataItem of Data" [name]="this.Shared.getName(dataItem.text)"
                                    type="bar" [data]="dataItem.value" [gap]="20" [spacing]="4">
                <kendo-chart-series-item-labels *ngIf="WithLabel" [format]="'n2'">
                </kendo-chart-series-item-labels>
            </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [categories]="Categories" >
            </kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
       
        
    </kendo-chart> -->
</ng-container>
<ng-container *ngIf="GraphType=='donut'">
    <kendo-chart [style]="newstyle">
        <ng-template kendoChartDonutCenterTemplate>
            {{data[1]['percentage']}}%
        </ng-template>
        <kendo-chart-title [text]="GraphTitle"></kendo-chart-title>
        <kendo-chart-legend [style]="chartLegendStyle" position="bottom" [padding]="0" [height]="300" [visible]="true">
        </kendo-chart-legend>
        <kendo-chart-series>
            <kendo-chart-series-item [type]="GraphType" [data]="data" [holeSize]="holeSize" categoryField="kind"
                field="share" colorField="colorField">
            </kendo-chart-series-item>
        </kendo-chart-series>
    </kendo-chart>
</ng-container>